var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-input",
    _vm._b(
      {
        directives: [
          {
            name: "validate",
            rawName: "v-validate.disable",
            value: _vm.validationRules,
            expression: "validationRules",
            modifiers: { disable: true }
          }
        ],
        attrs: {
          name: "salesTax",
          type: "number",
          min: "0",
          max: "100",
          suffix: "&nbsp;%",
          placeholder: _vm.$t("sales_tax")
        },
        on: { input: _vm.handleInput },
        model: {
          value: _vm.model,
          callback: function($$v) {
            _vm.model = $$v
          },
          expression: "model"
        }
      },
      "q-input",
      _vm.$attrs,
      false
    ),
    [
      _c("q-autocomplete", {
        attrs: {
          "static-data": { field: "label", list: _vm.salesTaxRates },
          "min-characters": 0
        },
        on: {
          show: function($event) {
            _vm.$emit("show")
          },
          hide: function($event) {
            _vm.$emit("hide")
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }